export interface GaiaSessionProperty {
    field: string;
    value: string | undefined;
    action: "update" | "add";
    [key: string]: string | undefined;
}

export interface BuildGaiaSessionPropertiesParams {
    mdn: string;
    countryCode: string | undefined;
    clientChannelId: string | undefined;
    previousDevices: string[] | undefined;
}

/**
 * Builds the properties array for the Gaia WebSocket session context update.
 * The hashed MDN must be computed asynchronously by the caller.
 */
export function buildGaiaSessionProperties(
    params: BuildGaiaSessionPropertiesParams,
    hashedMdn: string,
): GaiaSessionProperty[] {
    const { mdn, countryCode, clientChannelId, previousDevices } = params;

    const properties: GaiaSessionProperty[] = [
        { field: "hashed_mdn", value: hashedMdn, action: "update" },
        { field: "mdn", value: mdn, action: "update" },
        { field: "country_code", value: countryCode, action: "update" },
        { field: "client_channel_id", value: clientChannelId, action: "update" },
    ];

    if (previousDevices && previousDevices.length > 0) {
        properties.push({
            field: "previous_devices",
            value: previousDevices.join(","),
            action: "add",
        });
    }

    return properties;
}

/**
 * GAIA update-session-context requires that we do not send null or undefined values on the properties list.
 */
export function sanitizeGaiaSessionContextProperties(properties: Array<Record<string, unknown>>) {
    return properties.filter((prop) => prop.value !== null && prop.value !== undefined);
}
